import { formatOrgNum } from "../../utils/other";
import { observer } from "mobx-react";
import { Alert } from "../../components-v2/Alert";
import { ChangeOfAuditorForm } from "./auditorDomain";
import { useEffect } from "react";
import { VBox } from "../../components-v2/Box";
import { LoadingIndicator } from "../../components-v2/LoadingIndicator";
import { Autocomplete } from "../../components-v2/Autocomplete";
import { MTextInput } from "../../components-v2/TextInput";

import { useTranslation } from "../../stores/RootStoreContext";

const AuditorAutocomplete = observer(function AuditorAutocomplete({
  form,
}: {
  form: ChangeOfAuditorForm;
}) {
  const { t } = useTranslation();
  switch (form.auditors.state) {
    case "pending":
      return <LoadingIndicator />;
    case "failure":
      return <Alert type="error" message={t("decisions.auditor.error-loading-auditors")} />;
    case "cancelled":
      return <div />;
    case "ok":
      return (
        <VBox>
          <Autocomplete
            label={t("decisions.auditor.select")}
            disabled={form.isProjectLocked}
            items={form.auditors.data}
            idFn={(item) => item.organisationNumber}
            labelFn={(item) => item.name}
            value={form.selectedAuditor}
            onSelect={form.setSelectedAuditor}
            onClear={form.clearSelectedAuditor}
          />
          {form.validationError && (
            <Alert type={"error"} message={<>{t(form.validationError)}</>} />
          )}
        </VBox>
      );
  }
});

export const ChangeOfAuditorView = observer(function ChangeOfAuditorView({
  form,
}: {
  form: ChangeOfAuditorForm;
}) {
  const { t } = useTranslation();
  const orgNoPrefix = t("decisions.auditor.orgNoPrefix");

  useEffect(() => {
    form.init();
  }, [form]);

  return (
    <VBox gap={"md"}>
      {form.currentAuditor ? (
        <div>
          <div>{t("decisions.auditor.company-auditor-now")}</div>
          {form.currentAuditor &&
            `${form.currentAuditor.name} (${orgNoPrefix} ${formatOrgNum(
              form.currentAuditor.organisationNumber,
            )})`}
        </div>
      ) : (
        <div>
          <div>{t("decisions.auditor.company-no-auditor")}</div>
        </div>
      )}
      <AuditorAutocomplete form={form} />
      {form.selectedAuditor && (
        <VBox gap="md">
          <div>
            <div>{t("decisions.auditor.company-auditor-willbe")}</div>
            <strong>{form.selectedAuditor.name}</strong>
            {` (${orgNoPrefix} ${formatOrgNum(form.selectedAuditor.organisationNumber)})`}
          </div>
          <MTextInput model={form.emailModel} label={t("decisions.auditor.email")} />
        </VBox>
      )}
    </VBox>
  );
});
